const controller = '/pricing'
export default axios => ({
  getPackages(obj) {
    return axios.get(`${controller}`,obj)
  },
})
